import { render, staticRenderFns } from "./pixGenericTable.vue?vue&type=template&id=db393774&scoped=true"
import script from "./pixGenericTable.vue?vue&type=script&lang=js"
export * from "./pixGenericTable.vue?vue&type=script&lang=js"
import style0 from "./pixGenericTable.vue?vue&type=style&index=0&id=db393774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db393774",
  null
  
)

export default component.exports